module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bird_7e55b3.png";